/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevFailedIngestionDto
 */
export interface DevFailedIngestionDto {
    /**
     * 
     * @type {Date}
     * @memberof DevFailedIngestionDto
     */
    startedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DevFailedIngestionDto
     */
    failedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DevFailedIngestionDto
     */
    failedStep: string | null;
}

/**
 * Check if a given object implements the DevFailedIngestionDto interface.
 */
export function instanceOfDevFailedIngestionDto(value: object): value is DevFailedIngestionDto {
    if (!('startedAt' in value) || value['startedAt'] === undefined) return false;
    if (!('failedAt' in value) || value['failedAt'] === undefined) return false;
    if (!('failedStep' in value) || value['failedStep'] === undefined) return false;
    return true;
}

export function DevFailedIngestionDtoFromJSON(json: any): DevFailedIngestionDto {
    return DevFailedIngestionDtoFromJSONTyped(json, false);
}

export function DevFailedIngestionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevFailedIngestionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startedAt': (json['startedAt'] == null ? null : new Date(json['startedAt'])),
        'failedAt': (json['failedAt'] == null ? null : new Date(json['failedAt'])),
        'failedStep': json['failedStep'],
    };
}

export function DevFailedIngestionDtoToJSON(json: any): DevFailedIngestionDto {
    return DevFailedIngestionDtoToJSONTyped(json, false);
}

export function DevFailedIngestionDtoToJSONTyped(value?: DevFailedIngestionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startedAt': (value['startedAt'] == null ? null : (value['startedAt'] as any).toISOString()),
        'failedAt': (value['failedAt'] == null ? null : (value['failedAt'] as any).toISOString()),
        'failedStep': value['failedStep'],
    };
}

